module.exports = __webpack_public_path__ + "static/img/XhorseApp-Aboard.d942886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XhorseApp-Aboard.png
// module id = IqER
// module chunks = 0